import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import SplitPane from "react-split-pane";
import { FaDownload } from "react-icons/fa";
import { useParams } from "react-router";
import Moment from "react-moment";
import { CiSearch } from "react-icons/ci";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";
import Pagination from "../../../Pagination";
import FilePreview from "../../../LUPManagement/FileManagement/FilePreview";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ReportListing = ({ onMouseDown, tableRef, ids }) => {
  const [searchData, setSearchData] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [reportURL, setReportURL] = useState("");
  const [reportList, setReportList] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(reportCount / itemsPerPage);

  const getEDCLupReportList = async () => {
    setLoading(true)
    let data = await studyEDCLupReportingServices.getEDCLupReportList(
      "active",
      ids?.reportId,
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    )
    setReportList(data?.data || []);
    setReportCount(data?.count || 0);
    setLoading(false)
  }

  useEffect(() => {
    if (ids?.reportId) {
      getEDCLupReportList();
    }
  }, [ids?.reportId, searchData, pageNumber, itemsPerPage]);

  const downloadDocumentFile = async (reportURL) => {
    const anchor = document.createElement("a");
    anchor.href = reportURL;
    anchor.rel = "noopener noreferrer";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          {reportCount > 0 &&
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          }
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
        defaultSize={reportURL ? "60%" : "100%"}
      >
        {loading ? (
          <PageLoader />
        ) : reportCount === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG="Report list not found" />
          </div>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Name</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Type</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}
                    style={{ width: 120 }}>
                    GeneratedDt DT
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}
                    style={{ width: 120 }}>
                    Modified DT
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 5)}
                    style={{ width: 65 }}
                    className="text-center"
                  >
                    Download
                  </th>
                </tr>
              </thead>
              <tbody>
                {reportList?.map((item, index) => (
                  <tr
                    key={item?._id || index}
                    className={`CP ${uniqueId === item?._id ? "highlighted" : ""}`}
                    title="View Details"
                    onClick={() => {
                      setReportURL(item?.reportURL);
                      setUniqueId(item?._id);
                    }}
                  >
                    <td className="text-center">{index + 1 + startIndex}</td>
                    <td>{item?.name}</td>
                    <td className="text-uppercase">{item?.extension}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </td>
                    <td
                      className="text-center"
                      title={`Download ${item?.name}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadDocumentFile(item?.reportURL)
                      }}
                    >
                      <FaDownload />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={reportCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
        {reportURL && (
          <FilePreview FileUrl={reportURL} ref={null} HeightData={"calc(100vh - 71px)"} />
        )}
      </SplitPane>
    </>
  );
};

export default ReportListing;
